/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface MedicalComponentTaskType
 */
export interface MedicalComponentTaskType {
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    taskTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    taskTypeNameEn?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalComponentTaskType
     */
    deprecated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    featureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    nameKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    descriptionKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    referenceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    releaseDate?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalComponentTaskType
     */
    isMedicalComponent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    refIcon: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    hashIcon: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    udiNumber: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    udiIcon: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    ceIcon: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    mdIcon: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    dataMatrixCode: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalComponentTaskType
     */
    $type?: MedicalComponentTaskTypeTypeEnum;
}


/**
 * @export
 */
export const MedicalComponentTaskTypeTypeEnum = {
    PtwPtw100AppZeroCoreSharedLicenseComponentModelsMedicalComponentTaskTypePtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.LicenseComponent.Models.MedicalComponentTaskType, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type MedicalComponentTaskTypeTypeEnum = typeof MedicalComponentTaskTypeTypeEnum[keyof typeof MedicalComponentTaskTypeTypeEnum];


/**
 * Check if a given object implements the MedicalComponentTaskType interface.
 */
export function instanceOfMedicalComponentTaskType(value?: unknown): value is MedicalComponentTaskType {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(MedicalComponentTaskTypeTypeEnum)[0];
}

export function MedicalComponentTaskTypeFromJSON(json: any): MedicalComponentTaskType {
    return MedicalComponentTaskTypeFromJSONTyped(json, false);
}

export function MedicalComponentTaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalComponentTaskType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskTypeId': !exists(json, 'taskTypeId') ? undefined : json['taskTypeId'],
        'taskTypeNameEn': !exists(json, 'taskTypeNameEn') ? undefined : json['taskTypeNameEn'],
        'deprecated': !exists(json, 'deprecated') ? undefined : json['deprecated'],
        'featureId': !exists(json, 'featureId') ? undefined : json['featureId'],
        'nameKey': !exists(json, 'nameKey') ? undefined : json['nameKey'],
        'descriptionKey': !exists(json, 'descriptionKey') ? undefined : json['descriptionKey'],
        'referenceNumber': !exists(json, 'referenceNumber') ? undefined : json['referenceNumber'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'releaseDate': !exists(json, 'releaseDate') ? undefined : json['releaseDate'],
        'isMedicalComponent': !exists(json, 'isMedicalComponent') ? undefined : json['isMedicalComponent'],
        'refIcon': json['refIcon'],
        'hashIcon': json['hashIcon'],
        'udiNumber': json['udiNumber'],
        'udiIcon': json['udiIcon'],
        'ceIcon': json['ceIcon'],
        'mdIcon': json['mdIcon'],
        'dataMatrixCode': json['dataMatrixCode'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function MedicalComponentTaskTypeToJSON(value?: MedicalComponentTaskType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskTypeId': value.taskTypeId,
        'taskTypeNameEn': value.taskTypeNameEn,
        'deprecated': value.deprecated,
        'featureId': value.featureId,
        'nameKey': value.nameKey,
        'descriptionKey': value.descriptionKey,
        'referenceNumber': value.referenceNumber,
        'version': value.version,
        'releaseDate': value.releaseDate,
        'isMedicalComponent': value.isMedicalComponent,
        'refIcon': value.refIcon,
        'hashIcon': value.hashIcon,
        'udiNumber': value.udiNumber,
        'udiIcon': value.udiIcon,
        'ceIcon': value.ceIcon,
        'mdIcon': value.mdIcon,
        'dataMatrixCode': value.dataMatrixCode,
        '$type': value.$type,
    });
}

